import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, Layer } from 'components'
import { showMemberOutReasonLayerState, showMemberDropoutLayerState } from './states'
import { useRecoilState, useSetRecoilState } from 'recoil'
import MemberDropout from './MemberDropoutLayer'
import Lib from 'library'

const MemberOutReasonLayer = () => {

	const [showMemberOutReasonLayer, setShowMemberOutReasonLayer] = useRecoilState(showMemberOutReasonLayerState)
	const setShowMemberDropoutLayer = useSetRecoilState(showMemberDropoutLayerState)
	const [buttonDisabled, setButtonDisabled] = useState(true)

	const App = useApp()

	const [check, setCheck] = useState()
	const [etcDisable, setEtcDisable] = useState(false)
	const [outReason, setOutReason] = useState()
	const [commentText, setCommentText] = useState('') //기타 의견
	const [thinkPoolPay, setThinkPoolPay] = useState(); // 씽크풀 결제 정보

	//탈퇴 이유 기타 선택 시 textarea 오픈
	const onChange = (e) => {
		setCheck(e.target.id)
		if (e.target.id === "radio6") {
			setCommentText('')
			setEtcDisable(true)
		} else {
			setEtcDisable(false)
		}
		setOutReason(e.target.value)
	}

	const nextBtn = () => {
		// [결제상태와 무관하게 회원탈퇴 가능함에 따라 주석처리. 20221223]
		//if (thinkPoolPay && thinkPoolPay.payYn === "Y") { // 씽크풀 결제가 된 경우는 약관을 철회할 수 없음.
		//	let msg = `이용중인 상품이 있어 철회가 불가능해요.<br/>상품 이용 종료일${thinkPoolPay && thinkPoolPay.payEndDate.length >= 10 ? `(${thinkPoolPay.payEndDate.substring(0, 10).replace(/-/g, ".")})` : ``} 후에<br/>철회해주세요.`;
		//	App.showAlert(msg, () => {
		//	})
		//} else {
			if (etcDisable === true) {
				if (outReason.length > 3) {
					setShowMemberDropoutLayer(true)
				} else {
					App.alert('기타 의견을 입력해주세요.')
				}
			} else {
				setShowMemberDropoutLayer(true)
			}
		//}
	}

	const onComentText = (e) => {
		setCommentText(e.target.value)
		setOutReason('기타:' + e.target.value)
	}

	// 씽크풀 결제정보 조회 => [결제상태와 무관하게 회원탈퇴 가능함에 따라 주석처리. 20221223]
	//const getThinkPoolPayInfo = () => {
	//	Lib.post("/api/inner/thinkpool/payInfo", data => {
	//		setThinkPoolPay(data);
	//	})
	//}

	useEffect(() => {
		setButtonDisabled((!check || check === "radio6") && (check === "radio6" && !commentText))
	}, [check])

	useEffect(() => {
		setButtonDisabled(!commentText)
	}, [commentText])

	useEffect(() => {
		setOutReason('기타:' + commentText)
	}, [commentText])

	useEffect(() => {
		if (!showMemberOutReasonLayer) {
			setCheck()
			setCommentText()
			setEtcDisable()
		} else {
			// 씽크풀 결제정보 조회
			// 20221223 : 결제상태와 무관하게 회원탈퇴 가능함에 따라 주석처리
			//getThinkPoolPayInfo();
		}
	}, [showMemberOutReasonLayer])

	return (
		<Layer show={showMemberOutReasonLayer} closeLayer={() => setShowMemberOutReasonLayer(false)}>
			<div className="page">
				<div className="flex_1 padding">
					<h3>탈퇴하는 이유가 무엇인가요?</h3>

					<ul className="resign-list mt_40">
						<li>
							<div className="chk">
								<input type="radio" id="radio1" name="resign" onChange={onChange} value="이미 쓰고 있는 동일한 서비스가 있어요" />
								<label htmlFor="radio1">
									<span>이미 쓰고 있는 동일한 서비스가 있어요.</span>
								</label>
							</div>
						</li>
						<li>
							<div className="chk">
								<input type="radio" id="radio2" name="resign" onChange={onChange} value="이용이 불편하고 장애가 많아요" />
								<label htmlFor="radio2">
									<span>이용이 불편하고 장애가 많아요.</span>
								</label>
							</div>
						</li>
						<li>
							<div className="chk">
								<input type="radio" id="radio3" name="resign" onChange={onChange} value="사용빈도가 낮아요" />
								<label htmlFor="radio3">
									<span>사용빈도가 낮아요.</span>
								</label>
							</div>
						</li>
						<li>
							<div className="chk">
								<input type="radio" id="radio4" name="resign" onChange={onChange} value="탈퇴하고 다시 가입할래요" />
								<label htmlFor="radio4">
									<span>탈퇴하고 다시 가입할래요.</span>
								</label>
							</div>
						</li>
						<li>
							<div className="chk">
								<input type="radio" id="radio5" name="resign" onChange={onChange} value="앱을 어떻게 쓰는지 모르겠어요" />
								<label htmlFor="radio5">
									<span>앱을 어떻게 쓰는지 모르겠어요.</span>
								</label>
							</div>
						</li>
						<li>
							<div className="chk">
								<input type="radio" id="radio6" name="resign" onChange={onChange} value="기타:" />
								<label htmlFor="radio6">
									<span>기타</span>
								</label>
							</div>
						</li>
					</ul>
					{etcDisable &&
						<textarea placeholder="모니가 성장하도록 의견을 남겨주세요." onChange={onComentText} value={commentText} className="write-area mt_10" style={{ minHeight: "8rem" }} />
					}
				</div>
				<div className="flex-shrink_0 padding">
					<Button className="btn btn--big" disabled={buttonDisabled} onClick={() => nextBtn()}>다음</Button>
				</div>
			</div>

			<MemberDropout outReason={outReason} />
		</Layer>
	)
}

export default MemberOutReasonLayer